(function () {
    clientApp.controller('serviceCtrl', function ($scope, ngDialog, usSpinnerService, $http) {
        $scope.sendDisabled = false;
        $scope.sendBill = bill.sendBill($scope, ngDialog, usSpinnerService, $http);

        $scope.send = bill.send($scope, ngDialog, usSpinnerService, $http);

        $scope.sendExisting = bill.sendExisting($scope, ngDialog, usSpinnerService, $http);
    });
})();